import React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
export const PropertyCheckElement = observer(_ref => {
  let data = _ref.data,
    propertyId = _ref.propertyId,
    onSelect = _ref.onSelect,
    isHeader = _ref.isHeader,
    isHeaderChecked = _ref.isHeaderChecked;
  const store = useStore();
  return /*#__PURE__*/React.createElement(FormGroup, {
    key: propertyId
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    label: "",
    onChange: () => onSelect(data)
    // disabled={}
    ,
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: !!isHeader ? isHeaderChecked : store.portfoliosMultiActionStore.isSelected(propertyId)
    })
  }));
});